/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSwitch as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4051f95d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "padding-left": "20px"
  }
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("自定义登录方式");
const _hoisted_3 = {
  class: "form-item-col"
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存");
import { useAppStore } from '@/store/modules/app';
import UseConfig from '@/views/operate/base/configHook';
import { apiUsdkSwitchLoginDelete, apiUsdkSwitchLoginList, apiUsdkSwitchLoginUpdate } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  props: {
    item: null
  },
  setup(__props) {
    const props = __props;
    const gameInfo = computed(() => useAppStore().gameInfo);
    const {
      internalLogin,
      loginIcon
    } = UseConfig();
    const form = ref({});
    const radio = ref(1);
    const confirmLoading = ref(false);
    onMounted(() => {
      getProjectLogin();
      console.log({
        internalLogin
      });
    });
    const getProjectLogin = () => {
      apiUsdkSwitchLoginList({
        gid: gameInfo.value.Id,
        projectId: props.item.projectId
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length) {
            radio.value = 2;
            form.value = res.data[0];
          }
        }
      });
    };
    const handleSubmit = () => {
      confirmLoading.value = true;
      if (radio.value === 1) {
        apiUsdkSwitchLoginDelete({
          env: 1,
          projectId: props.item.projectId
        }).finally(() => {
          confirmLoading.value = false;
        });
      } else {
        apiUsdkSwitchLoginUpdate({
          gid: gameInfo.value.Id,
          env: 1,
          productId: props.item.productId,
          projectId: props.item.projectId,
          ...form.value
        }).finally(() => {
          confirmLoading.value = false;
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_el_radio = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_el_switch = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
        modelValue: radio.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => radio.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          label: 1
        }, {
          default: _withCtx(() => [_createTextVNode("使用分包来源(" + _toDisplayString(__props.item.originChannel) + ")的登录方式", 1)]),
          _: 1
        }), _createVNode(_component_el_radio, {
          label: 2
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form, {
        "label-col": {
          span: 11
        },
        "wrapper-col": {
          span: 5
        },
        labelAlign: "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(internalLogin), item => {
          return _openBlock(), _createBlock(_component_el_form_item, {
            key: item.type
          }, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
              src: _unref(loginIcon)[item.type],
              alt: "",
              style: {
                "margin-right": "3px"
              },
              width: "16"
            }, null, 8, _hoisted_5), _createTextVNode(_toDisplayString(item.label), 1)])]),
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value[item.type],
              "onUpdate:modelValue": $event => form.value[item.type] = $event,
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 2
          }, 1024);
        }), 128))])]),
        _: 1
      })], 512), [[_vShow, radio.value === 2]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
        loading: confirmLoading.value,
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});